export default {"src":"/_next/static/media/arrow-top.b6e1e0f0.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};